import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import "./ProductDetails.css";
import {BASE_URL} from "./Constants";
import { FiShare2 } from "react-icons/fi";
import { FiHelpCircle } from "react-icons/fi"
 

const ProductDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Description");
  const [product, setProduct] = useState(null);
  const [user, setUser] = useState(null);
  const [allProducts, setAllProducts] = useState([]);

  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [wishlistStatus, setWishlistStatus] = useState({});
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: ""
  });
  const [showAskUs, setShowAskUs] = useState(false);
  const [showSharePopup, setShowSharePopup] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await fetch(`${BASE_URL}/get_user_details`, {
          method: "GET",
          credentials: "include", // send HTTP-only cookie
        });
        if (!res.ok) throw new Error("Not logged in");
        const data = await res.json();
        setUser(data); // { user_id, email }
      } catch (err) {
        console.log("No user logged in:", err.message);
        setUser(null);
      }
    };
    fetchUser();
  }, []);
  // Fetch single product by ID

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await fetch(`${BASE_URL}/items?id=${id}`, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
          }
        });
        const data = await res.json();

        const products = Array.isArray(data)
          ? data
          : data.items || data.products || [];

          if (products.length > 0) {
            setProduct(products[0])
          }
      } catch (err) {
        console.error("Error fetching product:", err);
      }
    };
    fetchProduct();
  }, [id]);

  // Fetch all products for related items
  useEffect(() => {
    const fetchAll = async () => {
      try {
        const res = await fetch(`${BASE_URL}/items`, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
          }
        });
        const data = await res.json();
        setAllProducts(Array.isArray(data) ? data : data.items);
      } catch (err) {
        console.error("Error fetching all products:", err);
      }
    };
    fetchAll();
  }, []);

  if (!product) return <p>Loading product details...</p>;

  // Tab content
  const renderTabContent = () => {
    switch (activeTab) {
      case "Description":
      return (
        <div className="product-description">
          {/* ✅ Description */}
          {product.description && (
            <div className="desc-section">
              {typeof product.description === "object"
                ? Object.values(product.description).map((para, i) => (
                    <p key={i}>{para}</p>
                  ))
                : <p>{product.description}</p>}
            </div>
          )}
          <hr/>

          {/* ✅ Features */}
          {product.features && (
            <div className="features-section">
              <h4>Features:</h4>
              <ol>
                {typeof product.features === "object"
                  ? Object.values(product.features).map((feat, i) => (
                      <li key={i}>{feat}</li>
                    ))
                  : Array.isArray(product.features)
                  ? product.features.map((feat, i) => <li key={i}>{feat}</li>)
                  : <li>{product.features}</li>}
              </ol>
            </div>
          )}
          <hr/>

          {/* ✅ Package Includes */}
          {product.package_details && (
            <div className="package-section">
              <h4>Package Includes:</h4>
              {typeof product.package_details === "object"
                ? Object.values(product.package_details).map((pkg, i) => (
                    <p key={i}>{pkg}</p>
                  ))
                : Array.isArray(product.package_details)
                ? product.package_details.map((pkg, i) => <p key={i}>{pkg}</p>)
                : <p>{product.package_details}</p>}
            </div>
          )}
        </div>
      );

      case "Specification":
        return product.specification ? (
          <div className="specification-wrapper">
            <table className="specs-table">
              <tbody>
                {Object.entries(product.specification).map(([key, value], i) => (
                  <tr key={i}>
                    <td className="spce-value">
                       {Array.isArray(value)
                          ? value.join(", ")
                          : typeof value === "object"
                          ? Object.values(value).join(", ")
                          : value}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p>No specifications available</p>
        );

      case "Warranty":
        return (
        <div className="product-description">
          {/* ✅ Description */}
          {product.warranty_information && (
            <div className="desc-section">
              {typeof product.warranty_information === "object"
                ? Object.values(product.warranty_information).map((para, i) => (
                    <p key={i}>{para}</p>
                  ))
                : <p>{product.warranty_information}</p>}
            </div>
          )}
          </div>
        )

      case "videos":
        return product.videos && product.videos.length > 0 ? (
          <div className="video-gallery">
            {product.videos.map((vid, idx) => {
              const videoId =
                typeof vid === "object" && vid.id ? vid.id : Number(vid) || null;
              return videoId ? (
                <video key={videoId} controls width="400">
                  <source
                    src={`${BASE_URL}/download_videos/${videoId}`}
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              ) : (
                <p key={idx}>Invalid video data</p>
              );
            })}
          </div>
        ) : (
          <p>No videos available</p>
        );

      case "Attachments":
        return product.attachments && product.attachments.length > 0 ? (
          <div className="attachments-list">
            {product.attachments.map((att, idx) => {
              const attachmentId =
                typeof att === "object" && att.id ? att.id : Number(att) || null;
              return attachmentId ? (
                <div className="attachment-row" key={attachmentId}>
                  <span className="attachment-name">
                    {att.file_name ? att.file_name.toUpperCase() : `Attachment ${attachmentId}`}
                  </span>
                  <a
                    className="download-btn"
                    href={`${BASE_URL}/download_attachment/${attachmentId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    DOWNLOAD
                  </a>
                </div>
              ) : (
                <p key={idx}>Invalid attachment data</p>
              );
            })}
          </div>
        ) : (
          <p>No attachments available</p>
        );

      default:
          return null;
    }
  };

  const handleAddToCart = async (product) => {
    if (!user) {
      setMessage("Please login to add items to cart")
      setMessageType("error")
      navigate("/checkout/login");
      return;
    }

    try {
      // Fetch or create user cart
      let cartId;
      const resCart = await fetch(`${BASE_URL}/cart/fetch_cart_details?user_id=${user.user_id}`, {
        method: "GET",
        credentials: "include",
      });

      if (resCart.status === 404) {
        const createRes = await fetch(`${BASE_URL}/cart/create_cart`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ user_id: user.user_id }),
        });
        const data = await createRes.json();
        cartId = data.cart_id;
      } else {
        const data = await resCart.json();
        cartId = data.cart_id;
      }

      const imageUrl = product.images?.length
      ? `${BASE_URL}/download_images/${
          typeof product.images[0] === "object" ? product.images[0].id : product.images[0]
        }`
      : "/assets/default.jpg";

      const payload = {
        cart_id: Number(cartId),
        item_id: Number(product.item_id || product.id),
        quantity: 1,
        name: product.name,
        price: Number(product.price),
        image: imageUrl
      };

      const resAdd = await fetch(`${BASE_URL}/cart_items/add_items_to_cart`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(payload),
      });

      if (!resAdd.ok) throw new Error("Failed to add item to cart");

      window.dispatchEvent(new Event("cartUpdated"));
      setMessage(`${product.name} added to cart!`)
      setMessageType("success")
    } catch (err) {
      setMessage(`Failed to add item to cart: ${err.message}`)
      setMessageType("error")
    }
  };

  const handleAddToWishlist = async (product) => {
    if (!user) {
      setMessage("Please login to add items to wishlist")
      setMessageType("error")
      navigate("/checkout/login");
      return;
    }
    try {
      // Check if wishlist exists for user (optional)
      let wishlistId;
      const resWishlist = await fetch(`${BASE_URL}/wishlist/fetch_wishlist_details?user_id=${user.user_id}`, {
        method: "GET",
        credentials: "include",
      });

      if (resWishlist.status === 404) {
        // Create wishlist for user if it doesn't exist
        const createRes = await fetch(`${BASE_URL}/wishlist/create_wishlist`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ user_id: user.user_id }),
        });
        const data = await createRes.json();
        wishlistId = data.wishlist_id;
      } else {
        const data = await resWishlist.json();
        wishlistId = data.wishlist_id;
      }

      // Handle image URL if product has multiple images
      const imageUrl = product.images?.length
        ? `${BASE_URL}/download_images/${
            typeof product.images[0] === "object" ? product.images[0].id : product.images[0]
          }`
        : "/assets/default.jpg";

      const payload = {
        wishlistId: Number(wishlistId),
        item_id: Number(product.item_id),
        price: product.price,
        image: imageUrl,
        quantity: 1,
      };

      // Add item to backend wishlist
      const resAdd = await fetch(`${BASE_URL}/wishlist_items/add_items_to_wishlist`, {
        method: "POST",
        headers: { "Content-Type": "application/json", },
        credentials: "include",
        body: JSON.stringify(payload),
      });

      const data = await resAdd.json();

      if (!resAdd.ok) {
        setMessage(data.error || "Failed to add item");
        setMessageType("error");
        return;
      }

   if (data.already_exists) {
    setWishlistStatus((prev) => ({
      ...prev,
     [product.item_id]: "exists",
      }));
      setMessage(data.message || `${product.name} is already in wishlist`);
      setMessageType("info");

      return;
    }

    // success
    setWishlistStatus((prev) => ({
              ...prev,
              [product.item_id]: "added",
          }));
          setMessage(data.message || `${product.name} added to wishlist!`);
          setMessageType("success");
          } catch (err) {
              setMessage("Something went wrong");
              setMessageType("error");
        }
    };

  const handleAddToCartItem =async (product) => {
    if (!user) {
      setMessage("Please login to add items to cart")
      setMessageType("error")
      navigate("/checkout/login");
      return;
    }

    try {
      // Fetch or create user cart
      let cartId;
      const resCart = await fetch(`${BASE_URL}/cart/fetch_cart_details?user_id=${user.user_id}`, {
        method: "GET",
        credentials: "include",
      });

      if (resCart.status === 404) {
        const createRes = await fetch(`${BASE_URL}/cart/create_cart`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ user_id: user.user_id }),
        });
        const data = await createRes.json();
        cartId = data.cart_id;
      } else {
        const data = await resCart.json();
        cartId = data.cart_id;
      }

      const imageUrl = product.images?.length
      ? `${BASE_URL}/download_images/${
          typeof product.images[0] === "object" ? product.images[0].id : product.images[0]
        }`
      : "/assets/default.jpg";

      const payload = {
        cart_id: Number(cartId),
        item_id: Number(product.item_id || product.id),
        quantity: 1,
        name: product.name,
        price: Number(product.price),
        image: imageUrl
      };

      const resAdd = await fetch(`${BASE_URL}/cart_items/add_items_to_cart`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(payload),
      });

      if (!resAdd.ok) throw new Error("Failed to add item to cart");

      window.dispatchEvent(new CustomEvent("cartUpdated", { detail: { user_id: user.user_id } }));
      setMessage(`${product.name} added to cart!`)
      setMessageType("success")
      navigate("/cart");
    } catch (err) {
      setMessage(`Failed to add item to cart: ${err.message}`)
      setMessageType("error")
    }
  };

  const handleAddToWishlistItem = async (product) => {
    if (!user) {
      setMessage("Please login to add items to wishlist")
      setMessageType("error")
      navigate("/checkout/login");
      return;
    }
    try {
      // Check if wishlist exists for user (optional)
      let wishlistId;
      const resWishlist = await fetch(`${BASE_URL}/wishlist/fetch_wishlist_details?user_id=${user.user_id}`, {
        method: "GET",
        credentials: "include",
      });

      if (resWishlist.status === 404) {
        // Create wishlist for user if it doesn't exist
        const createRes = await fetch(`${BASE_URL}/wishlist/create_wishlist`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ user_id: user.user_id }),
        });
        const data = await createRes.json();
        wishlistId = data.wishlist_id;
      } else {
        const data = await resWishlist.json();
        wishlistId = data.wishlist_id;
      }

      // Handle image URL if product has multiple images
      const imageUrl = product.images?.length
        ? `${BASE_URL}/download_images/${
            typeof product.images[0] === "object" ? product.images[0].id : product.images[0]
          }`
        : "/assets/default.jpg";

      const payload = {
         wishlistId: Number(wishlistId),
        item_id: Number(product.item_id),
        price: product.price,
        image: imageUrl,
        quantity: 1,
      };

      // Add item to backend wishlist
      const resAdd = await fetch(`${BASE_URL}/wishlist_items/add_items_to_wishlist`, {
        method: "POST",
        headers: { "Content-Type": "application/json", },
        credentials: "include",
        body: JSON.stringify(payload),
      });

      const data = await resAdd.json();

      if (!resAdd.ok) {
  setMessage(data.error || "Failed to add item");
  setMessageType("error");
  return;
  }

  if (data.already_exists) {
 setWishlistStatus((prev) => ({
  ...prev,
  [product.item_id]: "exists",
  }));
  setMessage(data.message || `${product.name} is already in wishlist`);
  setMessageType("info");

  return;
  }

  // success
  setWishlistStatus((prev) => ({
  ...prev,
  [product.item_id]: "added",
  }));
  setMessage(data.message || `${product.name} added to wishlist!`);
  setMessageType("success");
} catch (err) {
setMessage("Something went wrong");
setMessageType("error");
}
  };

  const getStockStatus = (quantity) => {
    if (quantity <= 0) return "Out of Stock";
    if (quantity <= 5) return `Only ${quantity} left`;
    return "In Stock";
  };


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.message) return;
    try {
      const response = await fetch(`${BASE_URL}/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      if (response.ok) {
        setMessage("Message sent successfully");
        setMessageType("success");
        setFormData({ name: "", phone: "", email: "", message: "" });
        setShowAskUs(false);
      } else {
        alert(data.error || "Something went wrong");
      }
    } catch (error) {
      setMessage("Failed to send message");
      setMessageType("error");
    }
  };

  const shareLink = `${window.location.origin}/product/${product.item_id}`;
  const handleCopyLink = async() => {
    try {
      await navigator.clipboard.writeText(shareLink);
      setCopied(true);

    } catch(error) {
      console.error("copy failed", error);
    };
  }

  
  
  
  return (
    <>
      <div className="product-details-container">
        {/* Breadcrumb */}
        <div className="breadcrumb">
          <Link to="/">Home</Link> &gt; <Link to="/shop">Shop</Link> &gt;{" "}
          <span>{product.name}</span>
        </div>

        {/* Main Section */}
        <div className="product-main">
          {/* Left Section */}
          <div className="left-section">
            <div className="image-gallery">

              {/* MAIN IMAGE */}
              <div className="main-image">
                {product.images && product.images.length > 0 ? (
                  <img
                    src={`${BASE_URL}/download_images/${
                      typeof product.images[activeImageIndex] === "object"
                        ? product.images[activeImageIndex].id
                        : product.images[activeImageIndex]
                    }`}
                    alt="product"
                  />
                ) : (
                  <img src="/assets/default.jpg" alt="no-img" />
                )}
              </div>

              {/* THUMBNAILS */}
              <div className="thumbnail-row">
                {product.images?.map((img, index) => {
                  const imgId = typeof img === "object" ? img.id : img;

                  return (
                    <img alt="product"
                      key={index}
                      src={`${BASE_URL}/download_images/${imgId}`}
                      className={`thumbnail ${activeImageIndex === index ? "active-thumb" : ""}`}
                      onClick={() => setActiveImageIndex(index)}
                    />
                  );
                })}
              </div>

              {/* INDICATOR DOTS */}
              <div className="indicator-dots">
                {product.images?.map((_, i) => (
                  <span
                    key={i}
                    className={`dot ${activeImageIndex === i ? "active-dot" : ""}`}
                  ></span>
                ))}
              </div>

            </div>
          </div>

          {/* Right Section */}
          <div className="right-section">
            <h3>{product.name}</h3>

            <p className={`status ${product.quantity <= 0 ? "out-of-stock" : "in-stock"}`}>
              <strong>Availability:</strong> {getStockStatus(product.quantity)}
            </p>
            <hr />
            <h3>SKU:</h3>
            <p className="sku">{product.sku_no}</p>
            <p className="price">
              ₹ {product.price} <span>(Excl. GST)</span>
            </p>
            <div className="buttons">
              <input type="number" placeholder="Qty" defaultValue="1" min="1"/>
              {product.quantity > 0 && (
               <button className="add-to-cart" onClick={() => handleAddToCart(product)}>
                  Add to Cart
                </button>
              )}
              <button onClick={() => handleAddToWishlist(product)}>
                      {wishlistStatus[product.item_id] === "added"
                      ? "Added to Wishlist"
                      : wishlistStatus[product.item_id] === "exists"
                      ? "Already in Wishlist"
                      : "Add to Wishlist"}
              </button>
            </div>
            <hr />
            <div className="product-meta">
              <li>
                <strong>Brand:</strong> {product.brand}
              </li>
              <li>
                <strong>Category:</strong> {product.category}
              </li>
            </div>
            <div className="action-item" onClick={() => setShowAskUs(true)}>
              <span className="action-icon"><FiHelpCircle/></span>
              <span>ASK US</span>
            </div>

            <div className="action-item" onClick={() => setShowSharePopup(true)}>
              <span className="action-icon"> <FiShare2/></span>
              <span>Share</span>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="product-tabs">
          <div className="tab-buttons">
            {[
              "Description",
              "Specification",
              "Warranty",
              "videos",
              "Attachments",
            ].map((tab) => (
              <button
                key={tab}
                className={activeTab === tab ? "active" : ""}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
          <div className="tab-content">{renderTabContent()}</div>
        </div>

        {/* Related Products */}
        <div className="related-products">
          <h2>Related Products</h2>
          <div className="related-list">
            {Array.isArray(allProducts) &&
              allProducts
                .filter(
                  (item) =>
                    item.category === product.category &&
                    item.item_id !== product.item_id
                )
                .slice(0, 4)
                .map((related) => (
                  <div className="related-card" key={related.item_id}>
                    <div
                      onClick={() =>
                        navigate(`/product/${related.item_id}`, {
                          // state: { product: item, allProducts: products },
                        })
                      }
                    >
                      {related.images?.length > 0 && (
                        <img
                          src={`${BASE_URL}/download_images/${
                            typeof related.images[0] === "object"
                              ? related.images[0].id
                              : related.images[0]
                          }`}
                          alt={related.name}
                        />
                      )}
                      <h5>{related.name}</h5>
                    </div>
                    <p>₹ {related.price} (Excl. GST)</p>
                      <div className="related-buttons">
                        {related.quantity > 0 && (
                          <button
                            onClick={() => {
                              handleAddToCartItem(related);
                              navigate("/cart");
                            }}
                          >
                            Add to Cart
                          </button>
                        )}
                        <button onClick={() => handleAddToWishlistItem(related)}>
                          {wishlistStatus[related.item_id] === "added"
                            ? "Added to Wishlist"
                            : wishlistStatus[related.item_id] === "exists"
                            ? "Already in Wishlist"
                            : "Add to Wishlist"}
                        </button>
                      </div>
                  </div>
                ))}
          </div>
        </div>
      </div>
      {showAskUs && (
        <div className="askus-overlay" onClick={() => setShowAskUs(false)}>
          <div className="askus-modal" onClick={(e) => e.stopPropagation()}>
            <button className="askus-close" onClick={() => setShowAskUs(false)}>✕</button>
            <h3>Contact Form</h3>
            <div className="contact-left">
              <input
                type="text" name="name" placeholder="Your Name"
                value={formData.name} onChange={handleChange} required
              />
              <input 
                type="text" name="phone" placeholder="Your Phone"
                value={formData.phone} onChange={handleChange} required
              />
              <input
                type="email" name="email" placeholder="Your Email"
                value={formData.email} onChange={handleChange} required
              />
              <textarea
                className="message-input" name="message" placeholder="Your Message"
                value={formData.message} onChange={handleChange} required
              />
              <button  className="btn-primary" onClick={handleSubmit}>Submit</button>

              {message && (
                <div className={`global-msg ${messageType}`}>
                  {message}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {showSharePopup && (
        <div
          className="share-overlay"
          onClick={() => setShowSharePopup(false)}
        >

          <div
            className="share-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="share-close"
              onClick={() => setShowSharePopup(false)}
            >
              ✕
            </button>
            <h3>Share</h3>
            <div className="share-box">
              <input
                type="text"
                value={shareLink}
                readOnly
              />
              <div className="copy-wrapper">
                <button onClick={handleCopyLink}>
                  COPY
                </button>
                {copied && (
                  <span className="copied-tooltip">
                    Copied!
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </>
  );
};

export default ProductDetails;